/**
 * Vocabulary shared by the list and detail screens. The keys are exactly what
 * the API sends (`status`, `creditStatusKey`, `statusKey`) and what the
 * filters send back; the labels come from the API too, so nothing here has
 * to be kept in step with wording.
 */

export const PAYMENT_STATUS_OPTIONS = [
    { value: "captured", label: "Captured" },
    { value: "authorised", label: "Authorised" },
    { value: "initiated", label: "Initiated" },
    { value: "declined", label: "Declined" },
    { value: "failed", label: "Failed" },
    { value: "expired", label: "Expired" },
];

export const CREDIT_STATUS_OPTIONS = [
    { value: "none", label: "No credits" },
    { value: "partial", label: "Partly credited" },
    { value: "full", label: "Fully credited" },
    { value: "failed", label: "Credit failed" },
    { value: "pending", label: "Credit pending" },
];

export const NOT_PAID_STATUSES = ["declined", "failed", "expired"];

/** Bootstrap badge suffix for a payment status key. */
export const paymentBadge = (status) => {
    switch (status) {
        case "captured":
            return "success";
        case "authorised":
        case "initiated":
            return "warning";
        case "declined":
        case "failed":
            return "danger";
        default:
            return "secondary";
    }
};

/** Bootstrap badge suffix for a credit status key. */
export const creditBadge = (status) => {
    switch (status) {
        case "full":
            return "success";
        case "partial":
            return "info";
        case "pending":
            return "warning";
        case "failed":
            return "danger";
        default:
            return "light";
    }
};

/** Bootstrap badge suffix for one credit row's own status key. */
export const creditRowBadge = (statusKey) => {
    switch (statusKey) {
        case "succeeded":
            return "success";
        case "pending":
            return "warning";
        default:
            return "danger";
    }
};
